import React from 'react';
import axios from 'axios';
import FontAwesome from 'react-fontawesome';
import {Button, ControlLabel, Form, FormControl, FormGroup, HelpBlock, OverlayTrigger, Popover} from "react-bootstrap";
import Files from 'react-files';
import {withRouter} from "react-router-dom";

import Loading from "../../components/Loading/index";

import './style.css';

class BadgeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            file: [],
            inProcess: false,
            loading: this.props.match.params.id ? true : false,
            values: {
                name: '',
                description: ''
            },
            validation: {
                messages: {
                    name: '',
                    file: ''
                },
                states: {
                    name: null,
                    file: null
                }
            }
        };

        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeDescription = this.handleChangeDescription.bind(this);
        this.handleChangeImage = this.handleChangeImage.bind(this);
        this.handleClearImage = this.handleClearImage.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount() {
        if (this.props.sessionData && this.props.sessionData.accessToken) {
            this.getBadge();
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.sessionData && nextProps.sessionData.accessToken) {
            this.getBadge();
        }
    }

    getBadge() {
        if (this.props.match.params.id) {
            let loginToken = this.props.sessionData.accessToken;
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + loginToken
                }
            };
            axios.get(this.props.api.badges + "/" + this.props.match.params.id, config)
                .then((response) => {
                    if (!this._calledComponentWillUnmount) {
                        this.setState({
                            values: {
                                ...response.data
                            },
                            loading: false
                        });
                    }
                }).catch((error) => {
                    this.props.addNotification('error', error.response.status, 'Nepodařilo se načíst odznak!');
                    this.props.history.push('/badges');
                    console.log("Axios error: ", error);
            });
        }
    }

    // input handles
    handleChangeName(event) {
        let value =  event ? event.target.value : this.state.values.name;

        let values = this.state.values;
        values.name = value;

        let validation = this.state.validation;
        validation.states.name = value === '' ? 'error' : 'success';
        validation.messages.name = value === '' ? 'Název nesmí být prázdný!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeDescription(event) {
        let value =  event ? event.target.value : this.state.values.description;

        let values = this.state.values;
        values.description = value;

        this.setState({
            values
        });
    }

    // file input
    handleChangeImage(image) {
        let {file, values, validation} = this.state;

        if (image && image.length !== 0) {
            let file = image[0];
            let img = new Image();
            // let sizeLimit = this.props.size;
            let component = this;
            img.onload = function() {
                // let height = img.height;
                // let width = img.width;
                //
                // // dimension check
                // if (width !== sizeLimit.width || height !== sizeLimit.height) {
                //     file = [];
                //     values.badgeBase64 = undefined;
                //     validation.states.file = 'error';
                //     validation.messages.file = 'Rozměry fotky neodpovídají daným omezením!';
                //     component.setState({
                //         file,
                //         values,
                //         validation
                //     });
                // } else {
                //     file = image;
                //     let reader = new FileReader();
                //     reader.onload = function () {
                //         values.badgeBase64 = reader.result;
                //     };
                //     reader.readAsDataURL(file[0]);
                //     validation.states.file = 'success';
                //     validation.messages.file = '';
                //     component.setState({
                //         file,
                //         values,
                //         validation
                //     });
                // }

                file = image;
                let reader = new FileReader();
                reader.onload = function () {
                    values.badgeBase64 = reader.result;
                };
                reader.readAsDataURL(file[0]);
                validation.states.file = 'success';
                validation.messages.file = '';
                component.setState({
                    file,
                    values,
                    validation
                });

            };
            let _URL = window.URL || window.webkitURL;
            img.src = _URL.createObjectURL(file);
        } else {
            if ((file && file.length !== 0) || (this.props.match.params.id && this.state.values.filePath)) {
                validation.messages.file = '';
                validation.states.file = 'success';
            }
            else {
                validation.messages.file = 'Musíte vložit obrázek!';
                validation.states.file = 'error';
            }
        }

        this.setState({
            values,
            validation
        })
    }

    handleClearImage() {
        let {values, file} = this.state;
        file = [];
        values.badgeBase64 = undefined;
        this.setState({
            file,
            values
        });
        this.refs.file.removeFiles()
    }

    isValid () {
        this.handleChangeName();
        this.handleChangeImage();
        return (Object.values(this.state.validation.states).indexOf('error') < 0);
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.isValid()) {
            this.setState({
                inProcess: true
            });
            this.props.action(this.state.values);
        }
    }

    handleClose() {
        this.props.history.push('/badges');
    }

    render() {
        let title = this.props.title;
        let {messages, states} = this.state.validation;
        let {file, values} = this.state;

        const popoverInfo = (
            <Popover id="popover-info" title="Omezení nahráveného obrázku">
                <p>Obrázek musí splňovat tyto omezení:</p>
                <ul>
                    <li><strong>Velikost</strong> musí být {this.props.size.width}x{this.props.size.height}</li>
                    <li><strong>Formát obrázku</strong> musí být PNG.</li>
                </ul>
            </Popover>
        );


        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>{title}</h2>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    {
                        this.state.loading ? <Loading/> :
                            <Form onSubmit={this.handleSubmit}>
                                <div className="col-lg-offset-3 col-md-offset-3 col-sm-offset-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <FormGroup controlId="name" validationState={states.name}>
                                        <ControlLabel>Název <span className="required">*</span></ControlLabel>
                                        <FormControl type="text" value={values.name} onChange={this.handleChangeName}/>
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.name}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="description">
                                        <ControlLabel>Popis</ControlLabel>
                                        <FormControl componentClass="textarea" value={values.description}
                                                     onChange={this.handleChangeDescription}/>
                                    </FormGroup>
                                    <FormGroup controlId="file" validationState={states.file}>
                                        <ControlLabel>Obrázek</ControlLabel>
                                        <Files
                                            ref='file'
                                            className='files-dropzone-gallery-single'
                                            onChange={this.handleChangeImage}
                                            accepts={['image/png']}
                                            multiple={false}
                                            clickable
                                        >
                                            <FormControl.Feedback/>
                                            {
                                                file.length > 0
                                                    ? <div className='files-gallery-single'>
                                                        {file.map((file) =>
                                                            <img className='files-gallery-single-item' src={file.preview.url}
                                                                 alt='' key={file.id}/>
                                                        )}
                                                    </div>
                                                    : this.state.values.filePath ?
                                                    <img className='files-gallery-single-item'
                                                         src={`${__APIURL__}/${this.state.values.filePath}`} alt=''
                                                         key={values.id}/>
                                                    : <div>Zde vložte obrázek</div>
                                            }
                                        </Files>
                                        <Button type='button' className="btn btn-danger" onClick={this.handleClearImage}>Smazat</Button>
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="right"
                                                        overlay={popoverInfo}>
                                            <FontAwesome name="info-circle" tag="i" size="2x"/>
                                        </OverlayTrigger>
                                        <HelpBlock>{messages.file}</HelpBlock>
                                    </FormGroup>
                                    <div className="clearfix"/>
                                    <div className="ln-solid"/>
                                    <FormGroup>
                                        <div className="col-md-offset-4">
                                            <Button className="btn-primary" type="button"
                                                    onClick={this.handleClose}>Zpět</Button>
                                            <Button type="submit" className="btn btn-success">{this.props.button}</Button>
                                            {this.state.inProcess && <Loading/>}
                                        </div>
                                    </FormGroup>
                                </div>
                            </Form>
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(BadgeForm);



/** WEBPACK FOOTER **
 ** ./src/containers/Badges/BadgeForm.js
 **/